const initialState = {
  user: {},
  flash: {},
  currentDate: new Date(),
};

export default initialState;